// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_container_M6srB_dg9yh2WOB1DRol {
  font-family: Open Sans;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.style-module_container_M6srB_dg9yh2WOB1DRol > * {
  padding-top: 1rem;
}

.style-module_container_M6srB_dg9yh2WOB1DRol:last-child {
  margin-bottom: 5rem;
}

.style-module_moduleContainer_HiDiXLdWmXMiVk5kIrO0 {
  width: 50%;
  min-width: 55%;
}
@media screen and (max-width: 800px) {
  .style-module_moduleContainer_HiDiXLdWmXMiVk5kIrO0 {
    width: 100%;
  }
}

.style-module_title_f2lUrDU4wnBiHQ4sNGyA {
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: center;
}

.style-module_subtitle__Sp1dkRLV4YSgekD76Ed {
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
}

.style-module_description_Go1_8Q9JmDdWfxabJexU {
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/containers/AccountDeletion/AccountDeletionConfirmation/style.module.scss"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;AAEE;EACE,iBAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,UAAA;EACA,cAAA;AADF;AAGE;EAJF;IAKI,WAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAAF","sourcesContent":["\n.container {\n  font-family: Open Sans;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n\n  > * {\n    padding-top: 1rem;\n  }\n}\n\n.container:last-child {\n  margin-bottom: 5rem;\n}\n\n.moduleContainer {\n  width: 50%;\n  min-width: 55%;\n\n  @media screen and (max-width: 800px) {\n    width: 100%;\n  }\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: 0em;\n  text-align: center;\n}\n\n.subtitle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.description {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  letter-spacing: 0em;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style-module_container_M6srB_dg9yh2WOB1DRol`,
	"moduleContainer": `style-module_moduleContainer_HiDiXLdWmXMiVk5kIrO0`,
	"title": `style-module_title_f2lUrDU4wnBiHQ4sNGyA`,
	"subtitle": `style-module_subtitle__Sp1dkRLV4YSgekD76Ed`,
	"description": `style-module_description_Go1_8Q9JmDdWfxabJexU`
};
export default ___CSS_LOADER_EXPORT___;
